import manager from 'app/module46/component-manager.js';

console.log('registering ajax-form');
manager.register('ajax-form', ajaxForm);

/**
 * @param {HTMLFormElement} component
 * @param {Object.<string, Element>} references
 * @param {Array.<Element>} references.errors
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function ajaxForm(component, references, attributes, properties) {
	const url = component.action;

	const retroaction = document.createElement('div');
	component.prepend(retroaction);

	const { errorContainers } = references;

	/** @type {Object.<string, Element>} */
	const errorRefs = {};

	for (const errorContainer of errorContainers) {
		const id = errorContainer.id;
		const key = id.split('-')[1].trim();

		errorRefs[key] = errorContainer;
	}


	component.addEventListener('submit', (e) => {
		e.preventDefault();

		retroaction.classList.remove('msg-success');
		retroaction.classList.remove('msg-error');
		retroaction.innerHTML = '';

		for (const errorRef in errorRefs) {
			errorRefs[errorRef].innerHTML = '';
		}

		manager.api(url, new FormData(component), success, fail);

		return false;
	});

	/** @this XMLHttpRequest */
	function success(successResponse) {
		if (this.getResponseHeader('content-type') === 'application/json') {
			const { formMessage } = successResponse;

			// Show success message
			if (formMessage) {
				retroaction.classList.add('msg-success');
				retroaction.innerHTML = formMessage;
			}
		}
	}

	/** @this XMLHttpRequest */
	function fail(errorResponse) {
		if (this.getResponseHeader('content-type') === 'application/json') {
			const { errors, formMessage } = errorResponse;

			if (errors !== undefined) {

				for (const field in errors) {
					if (errorRefs.hasOwnProperty(field)) {
						const errorContainer = errorRefs[field];
						let html = '';

						for (const errorMsg of errors[field]) {
							html += `<small class="form__field_error">${errorMsg}</small>`;
						}

						errorContainer.innerHTML = html;
					}
				}
			}

			// Add general error message at the start of the form
			if (formMessage !== undefined) {
				retroaction.classList.add('msg-error');
				retroaction.innerHTML = formMessage;
			}
		}
	}
}
